import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ChipFieldComponent } from './chip-field.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldErrorMessagesModule } from '../field-error-messages/field-error-messages.module';
import { MatChipsModule } from '@angular/material/chips';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FieldErrorMessagesModule,
    MatChipsModule,
    SvgIconModule,
  ],
  declarations: [ChipFieldComponent],
  exports: [ChipFieldComponent],
})
export class ChipFieldModule {}
